import Button from 'components/Form/Button';
import Input from 'components/Form/Input';
import ContainerUnauthenticated from 'containers/Unauthenticated';
import { CoreContext } from 'context/CoreContext';
import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { DoLogin } from 'services/authentication';
import { exposeStrapiError } from 'utils';
import { ForgotLink, FormTitle, RegisterContent } from './styled';

export default function Login() {
  const history = useHistory();
  const navigate = (to) => history.push(`/${to}`);
  const [loading, setLoading] = useState(false);
  const { reloadMe } = useContext(CoreContext);
  const [form, setForm] = useState({});
  const formValue = (ref) => {
    return form?.[ref] ? form?.[ref] : '';
  };
  const changeForm = (value, ref) => {
    setForm({ ...form, [ref]: value });
  };
  const valid = (verbose = false) => {
    if (!formValue('identifier') || !formValue('identifier').length) {
      if (verbose) {
        toast.error('Preencha o campo: Email');
      }
      return false;
    }
    if (!formValue('password') || !formValue('password').length) {
      if (verbose) {
        toast.error('Preencha o campo: Senha');
      }
      return false;
    }
    return true;
  };
  const login = async () => {
    if (!valid(true)) {
      return;
    }
    setLoading(true);
    const result = await DoLogin({
      ...form,
      identifier: form.identifier?.replace(/ /g, ''),
    });
    setLoading(false);
    if (result && !exposeStrapiError(result)) {
      await reloadMe();
      completeLogin();
    }
  };
  const completeLogin = () => navigate('home');

  return (
    <>
      <ContainerUnauthenticated center>
        <RegisterContent>
          <FormTitle>Entrar</FormTitle>
          <Input
            placeholder="E-mail"
            value={formValue('identifier')}
            onChange={(e) => changeForm(e.target.value, 'identifier')}
          />
          <Input
            placeholder="Senha"
            type="password"
            value={formValue('password')}
            onChange={(e) => changeForm(e.target.value, 'password')}
            onSubmitEditing={login}
          />
          <ForgotLink onClick={() => navigate('forgot')}>
            Esqueceu a senha?
          </ForgotLink>
          <Button color="primary" loading={loading} onClick={login} gradient>
            Entrar
          </Button>
        </RegisterContent>
      </ContainerUnauthenticated>
    </>
  );
}
